import { token } from '@atlaskit/tokens';

export const TABLE_CLASS_PREFIX = 'connections-table';
export const ROW_BORDER_WIDTH = 1;

export const BORDER_COLOR = token('color.border');
export const ACCENT_BACKGROUND_COLOR = token('color.background.input.hovered');
